<template>
  <el-dialog
    :title="
      form.status === 'Disabled' ? 'View Subscription' : 'Edit Subscription'
    "
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="500px"
    @close="closeDialog()"
  >
    <div>
      <el-form ref="form" :model="form" label-width="100px" :rules="rules">
        <div class="desc-wrapper">
          <div class="desc-info w-57">
            {{ $t('text.details') | firstLetterCapitalize }}
          </div>
        </div>
        <el-form-item label="Code" prop="code">
          <el-input v-model="form.code" disabled></el-input>
        </el-form-item>
        <el-form-item label="Status" prop="isApproved">
          <el-select
            v-model="form.isApproved"
            placeholder="Please select"
            class="wp-100"
            v-if="form.status !== 'Disabled'"
            :disabled="form.status === 'Approved'"
          >
            <el-option
              v-for="(item, index) in statusOptions"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-input v-else v-model="form.status" disabled></el-input>
        </el-form-item>
        <el-form-item label="Expiry Date" prop="expiryDateTime">
          <el-date-picker
            v-model="form.expiryDateTime"
            type="datetime"
            class="wp-100"
            placeholder="Please select"
            :disabled="form.status === 'Disabled'"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="Created Date" prop="createdDateTime">
          <el-date-picker
            v-model="form.createdDateTime"
            type="datetime"
            class="wp-100"
            placeholder="Please select"
            disabled
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer" v-if="form.status !== 'Disabled'">
      <el-button
        class="save-btn min-w-80"
        @click="save()"
        :loading="loading"
        :disabled="form.status === 'Disabled'"
        >{{ $t('text.save').toUpperCase() }}</el-button
      >
      <el-button class="cancel-btn min-w-80" @click="closeDialog()">{{
        $t('text.cancel').toUpperCase()
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import moment from 'moment'
import ApiService from '@/services/CommonApiService.js'
import swal from 'sweetalert'
export default {
  data() {
    return {
      moment,
      loading: false,
      dialogVisible: false,
      form: {
        id: '',
        code: '',
        isApproved: '',
        expiryDateTime: '',
        createdDateTime: ''
      },
      statusOptions: [
        {
          label: 'Approved',
          value: true
        },
        {
          label: 'Trial',
          value: false
        }
      ],
      rules: {
        expiryDateTime: [
          {
            required: true,
            message: 'Please select expiry date time'
          }
        ]
      }
    }
  },
  methods: {
    openDialog() {
      this.dialogVisible = true
    },
    closeDialog() {
      this.resetForm()
      this.dialogVisible = false
    },
    save() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.expireCode()
        }
      })
    },
    expireCode() {
      if (
        moment(this.form.expiryDateTime).isBefore(
          moment(this.form.createdDateTime)
        ) ||
        moment(this.form.expiryDateTime).isBefore(moment())
      ) {
        swal({
          icon: 'warning',
          timer: 2000,
          title:
            'Expiry cannot be lower than current datetime and created datetime'
        })
        return false
      }
      this.loading = true
      ApiService.ExpireManufacturerCode({
        id: this.form.id,
        isApproved: this.form.isApproved,
        expiryDateTime: this.form.expiryDateTime
      })
        .then(response => {
          this.loading = false
          if (response.data.success) {
            swal({
              icon: 'success',
              timer: 2000,
              title: this.$t('text.saved_successfully')
            })
            this.$parent.getData()
            this.closeDialog()
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    },
    resetForm() {
      this.form = {
        id: '',
        code: '',
        isApproved: '',
        expiryDateTime: '',
        createdDateTime: ''
      }
      this.$refs.form.resetFields()
    }
  }
}
</script>
